import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const HIDE_INJECTED_CONTENT = 'hide-injected-content';

/**
 * This code block adds the class 'hide-injected-content' to the body element
 *
 * One main area we want to hide injected content is on the /call path
 * in the application. We can't use the useCallState hook, as we want this
 * code to be isomorphic and useCallState doesn't guard against window
 * being undefined.
 *
 * We don't need the granularity that useCallState provides, and this class
 * is mostly to control optional injected content that can be annoying but
 * not function breaking.
 */
export default function useHideInjectedContent(): void {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // remove trailing slash
    const cleanPathname = pathname.replace(/\/$/, '');

    if (cleanPathname.endsWith('/call')) {
      window.document.body.classList.add(HIDE_INJECTED_CONTENT);
    } else {
      window.document.body.classList.remove(HIDE_INJECTED_CONTENT);
    }
  }, [pathname]);
}
